import ticketEditComponent from './ticket-edit.component';

const ticketEditModule = angular.module('ticketEdit', [
])
  .component('ticketEdit', ticketEditComponent)
  .name;

export default ticketEditModule;
